/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ProviderResponse,
    ProviderResponseFromJSON,
    ProviderResponseToJSON,
} from '../models';

/**
 * no description
 */
export class ProviderApi extends runtime.BaseAPI {

    /**
     */
    async apiV2ProviderGetAllGetRaw(): Promise<runtime.ApiResponse<Array<ProviderResponse>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/Provider/GetAll`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderResponseFromJSON));
    }

    /**
     */
    async apiV2ProviderGetAllGet(): Promise<Array<ProviderResponse>> {
        const response = await this.apiV2ProviderGetAllGetRaw();
        return await response.value();
    }

}
